"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("styled-components/macro");

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _dayjs = _interopRequireDefault(require("dayjs"));

var _svg = require("../../svg/");

var _Inputs = require("../styles/Inputs.styles");

var _hooks = require("../../hooks");

var _Label = _interopRequireDefault(require("./Label"));

var _Errors = _interopRequireDefault(require("./Errors"));

var _validateInput = _interopRequireDefault(require("../validations/validateInput"));

var _FieldDescription = _interopRequireDefault(require("../../FieldDescription"));

var _validationsEnum = _interopRequireDefault(require("../constants/validationsEnum"));

var _dates = require("../../dates");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DateSelector = function DateSelector(_ref) {
  var id = _ref.id,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      validations = _ref.validations,
      _onChange = _ref.onChange,
      dependencies = _ref.dependencies,
      isFirstItem = _ref.isFirstItem,
      _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? [] : _ref$errors,
      typeOfDate = _ref.typeOfDate,
      _ref$formattingOption = _ref.formattingOptions.dateFormat,
      dateFormat = _ref$formattingOption === void 0 ? 'DD/MM/YYYY' : _ref$formattingOption,
      validationDependency = _ref.validationDependency,
      errorHandler = _ref.errorHandler,
      min = _ref.min,
      max = _ref.max,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      noFocus = _ref.noFocus,
      customLabel = _ref.customLabel,
      postErrors = _ref.postErrors,
      postErrorHandler = _ref.postErrorHandler,
      fieldDescription = _ref.fieldDescription,
      labelTooltip = _ref.labelTooltip,
      dateRange = _ref.dateRange,
      t = _ref.t;
  var codeRefs = {};
  var dateFormatObject = {};
  var initialState = {};
  var dateFormatArray = dateFormat.split('/');
  var rangeMin, rangeMax;

  if (typeOfDate === 'month') {
    dateFormatArray.splice(dateFormatArray.indexOf('DD'), 1);
    dateFormat = dateFormat.replace('DD/', '');
  }

  var calendarRef = (0, _react.useRef)();
  dateFormatArray.forEach(function (input) {
    codeRefs[input] = (0, _react.createRef)();
    dateFormatObject[input] = input.length;
    initialState[input] = '';
  });

  var _useReducer = (0, _react.useReducer)(function (state, newState) {
    return _objectSpread(_objectSpread({}, state), newState);
  }, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      date = _useReducer2[0],
      setDate = _useReducer2[1];

  var fullDateLength = Object.values(date).join('').length;
  var validationDepKey, validationDepValue;

  if (validationDependency) {
    var _Object$values$;

    validationDepKey = Object.keys(validationDependency)[0];
    validationDepValue = (_Object$values$ = Object.values(validationDependency)[0]) === null || _Object$values$ === void 0 ? void 0 : _Object$values$.toString();
  }

  var validationsArray = dependencies && dependencies[validationDepKey] && dependencies[validationDepKey][validationDepValue] ? (!value || value === '') && [].concat(_toConsumableArray(dependencies[validationDepKey][validationDepValue]), _toConsumableArray(validations || [])) : validations;

  var getRealValue = function getRealValue() {
    var realValue = '';
    Object.values(codeRefs).forEach(function (ref) {
      return realValue += ref.current.value;
    });
    return realValue;
  };

  var prevLength = (0, _hooks.usePrevious)(fullDateLength);

  var inputChangeHandler = function inputChangeHandler(_ref2) {
    var input = _ref2.input,
        e = _ref2.e;
    if (dateFormatObject[input] > date[input].length) setDate(_defineProperty({}, input, e.target.value));
  };

  if (dateRange !== null && dateRange !== void 0 && dateRange.enabled) {
    var getDays = function getDays(unit, count) {
      switch (unit) {
        case 'y':
          return count * 365;

        case 'm':
          return count * 30;

        default:
          return count;
      }
    };

    validationsArray.push(_validationsEnum.default.DATE_IS_BETWEEN_DATES);
    var dates = {
      from: undefined,
      to: undefined
    };
    Object.keys(dates).forEach(function (k) {
      if (dateRange[k].dateType === 'rel' && dateRange[k].count !== '') {
        var days = getDays(dateRange[k].unit, dateRange[k].count);
        dates[k] = dateRange[k].direction === 'past' ? (0, _dayjs.default)().subtract(days, 'd').format("YYYY-MM-DD") : (0, _dayjs.default)().add(days, 'd').format("YYYY-MM-DD");
      } else if (dateRange[k].dateType === 'abs') {
        dates[k] = dateRange[k].date;
      }
    });

    if (dates.to > dates.from || !dates.from && dateRange.from.direction === 'past' || !dates.to && dateRange.to.direction === 'future') {
      rangeMin = dates.from;
      rangeMax = dates.to;
    } else {
      rangeMin = dates.to;
      rangeMax = dates.from;
    }
  }

  var inputValidation = function inputValidation(valueToCheck) {
    (0, _validateInput.default)({
      value: valueToCheck,
      validations: validationsArray,
      validationDependency: validationDepValue,
      errorHandler: errorHandler,
      dependencies: dependencies,
      min: rangeMin,
      max: rangeMax,
      id: id
    });
  };

  var onKeyDownHandler = function onKeyDownHandler(_ref3) {
    var input = _ref3.input,
        e = _ref3.e;
    var invalidChars = [69, 187, 189, 188, 190, 229];
    if (invalidChars.includes(e.keyCode)) e.preventDefault();

    if (e.keyCode === 8) {
      e.preventDefault();
      setDate(_defineProperty({}, input, date[input].slice(0, -1)));
      var realValueLength = getRealValue().length;
      if (realValueLength <= date[dateFormatArray[0]].length) codeRefs[dateFormatArray[0]].current.focus();
      if (realValueLength > date[dateFormatArray[0]].length && realValueLength <= date[dateFormatArray[0]].length + date[dateFormatArray[1]].length) codeRefs[dateFormatArray[1]].current.focus();
      if (dateFormatArray.length === 3 && realValueLength > date[dateFormatArray[0]].length + date[dateFormatArray[1]].length) codeRefs[dateFormatArray[2]].current.focus();
    } else {
      if (dateFormatArray[0].length === date[dateFormatArray[0]].length) codeRefs[dateFormatArray[1]].current.focus();
      if (dateFormatArray.length === 3 && dateFormatArray[0].length === date[dateFormatArray[0]].length && dateFormatArray[1].length === date[dateFormatArray[1]].length) codeRefs[dateFormatArray[2]].current.focus();
    }
  };

  (0, _react.useEffect)(function () {
    if (date[dateFormatArray[0]].length === 0 && isFirstItem) codeRefs[dateFormatArray[0]].current.focus(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(function () {
    if (prevLength && prevLength !== fullDateLength) {
      if (fullDateLength === 8) {
        if (postErrors) {
          postErrorHandler(id);
        }

        _onChange(id, "".concat(date.YYYY, "-").concat(date.MM, "-").concat(date.DD));
      } else if (typeOfDate === 'month' && fullDateLength === 6) {
        if (postErrors) {
          postErrorHandler(id);
        }

        _onChange(id, "".concat(date.YYYY, "-").concat(date.MM));
      } else if (prevLength === 1 && fullDateLength === 0) {
        if (postErrors) {
          postErrorHandler(id);
        }

        _onChange(id, '');
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [fullDateLength]);
  (0, _react.useEffect)(function () {
    var formattedDate = (date.YYYY || date.MM || date.DD) && "".concat(date.YYYY, "-").concat(date.MM, "-").concat(date.DD);
    typeOfDate === 'date' && inputValidation(formattedDate);
    typeOfDate === 'month' && inputValidation("".concat(date.MM));
    typeOfDate === 'year' && inputValidation("".concat(date.YYYY));
  }, [typeOfDate, date.DD, date.MM, date.YYYY]);
  (0, _react.useEffect)(function () {
    var formattedValue = (value === null || value === void 0 ? void 0 : value.length) <= 2 ? undefined : value;
    var formattedDate = typeOfDate === 'date' ? formattedValue : value;
    if (validationsArray) inputValidation(formattedDate); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  (0, _react.useEffect)(function () {
    if (dependencies) inputValidation(value); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validationDepValue]);
  (0, _react.useEffect)(function () {
    if (isFirstItem && !noFocus) codeRefs[dateFormatArray[0]].current.focus(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(function () {
    if (value) {
      var formattedDate = (0, _dates.formatDate)(value, dateFormat);

      if (formattedDate !== "Invalid date") {
        var splittedDate = formattedDate.split('/');
        dateFormatArray.map(function (item, index) {
          return setDate(_defineProperty({}, item, splittedDate[index]));
        });
      } else {
        errorHandler(_defineProperty({}, id, ['errors.dateIsNotValid']));
      }
    } else {
      dateFormatArray.map(function (item) {
        return setDate(_defineProperty({}, item, ''));
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [value]);
  return _react.default.createElement(_react.default.Fragment, null, customLabel && _react.default.createElement(_Label.default, {
    customLabel: customLabel,
    tooltip: labelTooltip,
    margin: "0"
  }), fieldDescription && _react.default.createElement(_FieldDescription.default, {
    value: fieldDescription
  }), _react.default.createElement(_Inputs.DateAndCalendar, {
    responsive: true,
    alignItems: "center"
  }, _react.default.createElement(_Inputs.FlexDate, null, dateFormatArray.map(function (input, i) {
    return _react.default.createElement(_Inputs.InputBlockCalendar, {
      type: "number",
      disableUnderline: true,
      inputRef: codeRefs[input],
      key: i,
      min: min,
      max: max,
      disabled: disabled,
      value: date[input],
      onInput: function onInput(e) {
        return inputChangeHandler({
          input: input,
          e: e
        });
      },
      onKeyDown: function onKeyDown(e) {
        return onKeyDownHandler({
          input: input,
          e: e
        });
      },
      placeholder: input,
      lastChild: dateFormatArray.length === i + 1,
      numOfElements: dateFormatArray.length
    });
  })), _react.default.createElement(_Inputs.CalendarWrapper, null, disabled ? null : _react.default.createElement(_Inputs.Calendar, {
    ref: calendarRef,
    type: typeOfDate || 'date',
    onChange: function onChange(e) {
      if (postErrors) {
        postErrorHandler(id);
      }

      _onChange(id, e.target.value);
    }
  }), _react.default.createElement(_Inputs.CalendarButton, {
    value: _react.default.createElement(_svg.Calendar, {
      fill: "white",
      size: "16"
    }),
    fixDimension: {
      width: '100%'
    },
    disabled: disabled
  }))), _react.default.createElement(_Errors.default, {
    errors: postErrors ? [].concat(_toConsumableArray(errors), [postErrors.message]) : errors,
    t: t
  }));
};

var _default = _react.default.memo(DateSelector, _isEqual.default);

exports.default = _default;